import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#111111] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="/logo-transparent.png"
              alt="Multicolor International"
              className="h-20 w-auto object-contain mb-4 bg-white/95 p-3 rounded-lg"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Leading printing, packaging, and branding solutions company since 1952.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-gray-400 hover:text-white transition">
                Home
              </Link>
              <Link to="/portfolio" className="block text-sm text-gray-400 hover:text-white transition">
                Portfolio
              </Link>
              <Link to="/products" className="block text-sm text-gray-400 hover:text-white transition">
                Products
              </Link>
              <Link to="/contact" className="block text-sm text-gray-400 hover:text-white transition">
                Contact
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-400">129-C Rehmanpura, Lahore, Pakistan</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} className="flex-shrink-0" />
                <span className="text-sm text-gray-400">0321-4121313</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} className="flex-shrink-0" />
                <a href="mailto:multicolor13@yahoo.com" className="text-sm text-gray-400 hover:text-white transition">
                  multicolor13@yahoo.com
                </a>
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4">Follow Us</h4>
            <a
              href="https://www.instagram.com/multicolorinternational"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-sm text-gray-400 hover:text-white transition"
              data-testid="footer-instagram-link"
            >
              <Instagram size={20} />
              <span>Instagram</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Multicolor International. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;